import React, { useState, useEffect, useContext, Fragment } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import MonthPickerComponent from '../../Utils/MonthPickerComponent'
import { TableDownloadContext } from "../../Contexts/TableDownloadContext";
import xls from "../../images/xls/png/Group 47.png";
import FileIcon from "../../images/file.png";
import FileIconBlur from "../../images/fileblur.png";
import ExcelPopup from "../../Components/ExcelPopup";
import line from "../../images/line.png";
import moment from 'moment';
import '../MainMenu.css'
import { PeFilterContext } from "../../Contexts/PeFilterContext";
import { Popover, Transition } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/solid'

import {
    ArrowPathIcon, PlusCircleIcon, ChartBarIcon, UserGroupIcon, CursorArrowRaysIcon, DocumentChartBarIcon, ShieldCheckIcon, Squares2X2Icon,
} from '@heroicons/react/outline'
import { routeNames } from "../../routeSegments";
import SavedFilterICON from "../SavedFilter/SavedFilterICON";
import SavedFilterContent from "../SavedFilter";
import { Tooltip } from "antd";
import { RiMailDownloadLine } from "react-icons/ri";
import DownloadTrigger from "../ExportPopup/DownloadTrigger";


const solutions = [
    { name: 'via M&A(PE-VC)', href: '#', icon: ShieldCheckIcon },
    { name: 'M&A(VC)', href: '#', icon: UserGroupIcon },
    { name: 'via Public Market(PE-VC)', href: '#', icon: PlusCircleIcon },
    { name: 'Public Market(VC)', href: '#', icon: ShieldCheckIcon },

]

/**
 * The `classNames` function takes in multiple class names as arguments and returns a string with all
 * the non-empty class names joined together with a space separator.
 * @param classes - The `classes` parameter is a rest parameter, which means it allows you to pass any
 * number of arguments to the function. In this case, it is used to accept multiple class names as
 * arguments.
 * @returns a string that contains all the non-empty classes joined together with a space between each
 * class.
 */
function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

/**
 * The MainMenu function is a React component that renders a menu with tabs and various options,
 * including a month picker and a download button.
 * @param props - The props parameter is an object that contains the properties passed to the MainMenu
 * component. These properties can be accessed using dot notation, such as props.active, props.menu,
 * props.primaryTypeMasterId, props.subTypeMasterId, and props.typeId.
 * @returns The function `MainMenu` returns JSX elements.
 */
function MainMenu(props) {
  const [connection, setConnection] = useState(true);
  const [showFilterSave, setshowFilterSave] = useState(false)
  const {
    monthPickerValue,
    setMonthPickerValue,
    isMonthPickerChanged,
    setIsMonthPickerChanged,
    isTagClosed,
    setIsTagClosed,
  } = useContext(PeFilterContext);

  const { handleDownloadExcel } = useContext(TableDownloadContext);
  const [openTab, setOpenTab] = React.useState(1);
  const [showPopup, setShowPopup] = useState(false);
  const [date, setDate] = useState([
    moment().startOf("month").subtract(12, "months").format("YYYY-MM-DD"),
    moment().endOf("month").format("YYYY-MM-DD"),
  ]);

  /* The `useEffect` hook is used to perform side effects in a functional component. In this case, the
  `useEffect` hook is used to set the value of the `openTab` state variable to the value of the
  `props.active` property whenever `openTab` changes. */
  useEffect(() => {
    setOpenTab(props.active);
  }, [openTab]);

  /**
   * The download function calls the handleDownloadExcel function.
   */
  const download = () => {
    handleDownloadExcel();
  };
  return (
    <>

      <div className="pl-3 pr-4">
        <div className="scrollbar  rounded shadow-[0_2px_6px_0_rgba(0,0,0,0.08)]">
          <div
           className="px-2  md:px-3 rounded-[6px] rounded-b-none bg-white block lg:flex flex-row justify-between  ">
             {
            
            
            props?.menu == "re" ? (
              <div className="hidden md:flex flex-row overflow-x-auto ">
                <div className="flex flex-row space-x-3 ">
                <div className="lg:py-4 py-5">
                  <NavLink
                    className={
                      "whitespace-nowrap lg:text-[14px] lg:leading-[17px] text-[14pt] leading-[17pt] " +
                      (openTab === 1
                        ? "text-[#333333] font-sans_semi_bold border-b-[3px] border-[#F1CA75] py-4 pt-[1.1rem]"
                        : " whitespace-nowrap font-sans_medium_body text-[#333333] opacity-[.4] hover:opacity-100   ")
                    }
                    
                    data-toggle="tab"
                    to={routeNames.re_investors_re_investments}
                    role="tablist"
                  >
                    PE-RE Investments

                  </NavLink>
              
                </div>
                
                <div className="lg:py-4  py-5 lg:pl-1 pl-2 ">
                  <NavLink
                    className={
                      "whitespace-nowrap lg:text-[14px] lg:leading-[17px] text-[14pt] leading-[17pt] " +
                      (openTab === 2
                        ? "text-[#333333] font-sans_semi_bold border-b-[3px] border-[#F1CA75] py-4 pt-[1.1rem]"
                        : " whitespace-nowrap font-sans_medium_body text-[#333333] opacity-[.4] hover:opacity-100   ")
                    }
                  
                    data-toggle="tab"
                    to={routeNames.re_investors_exists}
                    role="tablist"
                  >
                    PE-RE Exits via M&A

                  </NavLink>
                </div>
                <div className="lg:py-4  py-5 lg:pl-1 pl-2 ">
                  <NavLink
                    className={
                      "whitespace-nowrap lg:text-[14px] lg:leading-[17px] text-[14pt] leading-[17pt] " +
                      (openTab === 3
                        ? "text-[#333333] font-sans_semi_bold border-b-[3px] border-[#F1CA75] py-4 pt-[1.1rem]"
                        : " whitespace-nowrap font-sans_medium_body text-[#333333] opacity-[.4] hover:opacity-100   ")
                    }
                  
                    data-toggle="tab"
                    to={routeNames.re_investors_other_ma}
                    role="tablist"
                  >
                    Other M&A

                  </NavLink>
                </div>

                <div className="lg:py-4 py-5 pl-4  lg:pl-3">
                  <NavLink
                    className={
                      "whitespace-nowrap lg:text-[14px] lg:leading-[17px] text-[14pt] leading-[17pt] " +
                      (openTab === 4
                        ? "text-[#333333] font-sans_semi_bold border-b-[3px] border-[#F1CA75] py-4 pt-[1.1rem]"
                        : " whitespace-nowrap font-sans_medium_body text-[#333333] opacity-[.4] hover:opacity-100  ")
                    }
                    // onClick={e=> {
                    //     e.preventDefault();
                    //     setOpenTab(4)
                    // }}
                    data-toggle="tab"
                    to={routeNames.re_investors_backed_ipos}
                    role="tablist"
                  >
                    PE-RE Backed IPOs
                  </NavLink>
                </div>
             
            </div>
           </div>
            ) 
            : ""
             
            }
            
            <div className="flex justify-between items-center px-5 lg:px-2 py-2">
              <label htmlFor="" className="text-[#666666] w-[45%] ">
                <div className="flex">
                  <MonthPickerComponent  />
                </div>
              </label>
              <div className="flex">
                <a className=" px-4">
                  {/* <button onClick={download}> */}
                  <button>
                    <DownloadTrigger onClick={() => setShowPopup(!showPopup)} />

                    {showPopup && (
                      <div>
                        <ExcelPopup
                          showPop={showPopup}
                          setShowPop={setShowPopup}
                        />{" "}
                      </div>
                    )}
                  </button>
                </a>
                <a>
                  <img className="h-[24px] w-[2px] mt-1 " src={line} />
                </a>
                {/* <a className="pl-4 group cursor-pointer">
                  <div className="group-hover:hidden">
                    <img
                      src={FileIconBlur}
                      className="h-[24px] mt-1 w-[21px]"
                      alt=""
                    />
                  </div>

                  <div className="hidden group-hover:flex">
                    <img
                      src={FileIcon}
                      className="h-[24px] mt-1 w-[21px]"
                      alt=""
                    />
                  </div>
                </a> */}
                 <SavedFilterICON
                          save={showFilterSave} 
                          FileIcon={FileIcon} 
                          FileIconBlur={FileIconBlur}   
                          savedList={()=>setshowFilterSave(prev=>!prev)}  /> 
              </div>
            </div>
          </div>
          {showFilterSave&&<SavedFilterContent primaryTypeMasterId={props.primaryTypeMasterId}
                                subTypeMasterId={props.subTypeMasterId}
                                typeId={props.typeId}
                                show={showFilterSave}
                                 />}
        </div>
      </div>
    </>
  );
}

export default MainMenu;
